import React from "react";
import "./News.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const News = () => {
  return (
    <div className="mt-16 mx-12">
      <h2 className="news-h2">Khukumoni Foundation’s on News</h2>
      <>
        <Swiper
          slidesPerView={1}
          spaceBetween={30}
          loop={true}
          navigation={true}
          modules={[Navigation]}
          className="mySwiper mt-12 lg:mt-20">
          <SwiperSlide>
            <div className="flex justify-center gap-8">
              <div>
                <video loop controls muted preload="metadata" playsInline  controlsList="nodownload" disablePictureInPicture  onContextMenu={(e) => e.preventDefault()} className="w-full max-w-[500px] rounded-2xl">
                  <source src='https://res.cloudinary.com/dnivqqmqv/video/upload/q_auto/f_auto/v1779429685/Somoy_TV_dp3ffg.mp4' type="video/mp4" />
                </video>
                <h1 className="mt-4 text-center text-2xl lg:font-bold font-medium">
                  Somoy TV
                </h1>
              </div>
              <div>
                <video loop controls muted preload="metadata" playsInline controlsList="nodownload" disablePictureInPicture  onContextMenu={(e) => e.preventDefault()} className="w-[500px] rounded-2xl">
                  <source src='https://res.cloudinary.com/dnivqqmqv/video/upload/q_auto/f_auto/v1779429816/Jamuna_TV_stpzpc.mp4' type="video/mp4" />
                </video>
                <h1 className="mt-4 text-center text-2xl lg:font-bold font-medium">
                  Jamuna TV
                </h1>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="flex justify-center gap-8">
              <div>
                <video loop controls muted preload="metadata" playsInline controlsList="nodownload" disablePictureInPicture  onContextMenu={(e) => e.preventDefault()} className="w-[500px] rounded-2xl">
                  <source src='https://res.cloudinary.com/dnivqqmqv/video/upload/q_auto/f_auto/v1779428827/Ekattor_TV_arxhrg.mp4' type="video/mp4" />
                </video>
                <h1 className="mt-4 text-center text-2xl font-bold">Ekattor TV</h1>
              </div>
              <div>
                <video
                  loop
                  controls muted preload="metadata" playsInline controlsList="nodownload" disablePictureInPicture  onContextMenu={(e) => e.preventDefault()}
                  className="w-[500px] h-[80px] lg:h-[285px] rounded-2xl">
                  <source src='https://res.cloudinary.com/dnivqqmqv/video/upload/q_auto/f_auto/v1779429822/GTV_dj08nf.mp4' type="video/mp4" />
                </video>
                <h1 className="mt-4 text-center text-2xl font-bold">GTV</h1>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </>
    </div>
  );
};

export default News;
